var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TabComponent_1;
import { css, html, nothing } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement } from 'lit/decorators.js';
import { StringUtils } from '../../utils/string-utils.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
let TabComponent = class TabComponent extends GGOBaseComponent {
    static { TabComponent_1 = this; }
    static { this.properties = {
        sections: { type: Object },
        doRender: { type: Boolean },
    }; }
    static get styles() {
        return [...super.styles,
            css `
          .slds-radio_button__label {
            height: 2.4rem;
            display: flex;
            justify-content: center;
          }
          .slds-radio_button__label>.slds-radio_faux {
            line-height: 2rem;
          }
      `,
        ];
    }
    render() {
        let currentSection = this.sections?.find((section) => section.isActive);
        if (!currentSection && this.sections?.length > 0) {
            this.sections[0].isActive = true;
        }
        return html `<div class="slds-tabs_default slds-tabs_medium">
      <ul class="slds-tabs_default__nav" role="tablist">
        ${this.sections.map((section) => this.renderTab(section))}
      </ul>
      ${this.sections.map((section) => this.renderContent(section))}
    </div>`;
    }
    onTabSelected(content) {
        for (let section of this.sections) {
            section.isActive = section.label === content.label;
        }
        this.dispatchEvent(new CustomEvent('changed', { detail: content }));
        this.doRender = !this.doRender;
    }
    static getTabId(tabContent) {
        return `tab-${StringUtils.sanitize(tabContent.label)}`;
    }
    renderTab(tabContent) {
        const isSelected = tabContent.isActive;
        return html `
      <li class="slds-tabs_default__item ${tabContent.isActive ? 'slds-is-active' : ''}" title="${tabContent.label}" role="presentation">
        <a
          @click="${() => this.onTabSelected(tabContent)}"
          class="slds-tabs_default__link"
          href="#"
          role="tab"
          tabindex="0"
          aria-selected="true"
          aria-controls="${TabComponent_1.getTabId(tabContent)}"
          id="${TabComponent_1.getTabId(tabContent)}__item"
          >${tabContent.label}</a
        >
      </li>
    `;
    }
    static getContent(tabContent) {
        if (typeof tabContent.content === 'string') {
            return unsafeHTML(tabContent.content);
        }
        else if (typeof tabContent.content === 'function') {
            return tabContent.content();
        }
        else if (typeof tabContent.content === 'object') {
            return tabContent.content;
        }
        else {
            throw new Error('No content or content callback defined ' + typeof tabContent.content);
        }
    }
    renderContent(tabContent) {
        if (!tabContent.isActive)
            return nothing;
        return html `
      <div
        id="${TabComponent_1.getTabId(tabContent)}"
        class="slds-tabs_default__content slds-show"
        role="tabpanel"
        aria-labelledby="${TabComponent_1.getTabId(tabContent)}__item"
      >
        ${TabComponent_1.getContent(tabContent)}
      </div>
    `;
    }
};
TabComponent = TabComponent_1 = __decorate([
    customElement('ggo-tab')
], TabComponent);
export { TabComponent };
